module.exports = __webpack_public_path__ + "img/icon-mail.5559b0ee.png";